<div class="mr-icon-badge" [attr.data-variant]="block.variant || null">
  <span class="circle">
    <mat-icon fontSet="material-icons-outlined">{{ block.icon }}</mat-icon>
  </span>
</div>
